"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const collections_1 = require("@angular/cdk/collections");
const Constants_1 = require("./Constants");
class VasatDataSource extends collections_1.DataSource {
    constructor(searchQuery, _sort, page) {
        super();
        this.searchQuery = searchQuery;
        this._sort = _sort;
        this.page = page;
        this.debug = Constants_1.Constants.debug_off;
        this.refreshSubject = new rxjs_1.Subject();
        this.injectSubject = new rxjs_1.Subject();
        this.injectObs = this.injectSubject.asObservable();
        this.loadedSubject = new rxjs_1.Subject();
        if (this.searchQuery.queryParams && this.searchQuery.queryParams['query']) {
            this.baseQuery = JSON.parse(this.searchQuery.queryParams['query']);
            delete this.searchQuery.queryParams['query'];
        }
        this.page.pageSize = 40;
        if (this.debug) {
            console.log('dataSource.ts :: construct()', page);
        }
    }
    clear() {
        if (this.debug) {
            console.log('datasource.ts :: clear()');
        }
        this.baseQuery = null;
        this.dateQuery = null;
        this.filterQuery = null;
        this.searchText = null;
        this.assetTypeQuery = null;
    }
    refresh() {
        if (this.debug) {
            console.log('datasource.ts :: refresh()');
        }
        this.refreshSubject.next();
    }
    /** Connect function called by the table to retrieve one stream containing the data to render. */
    connect(col) {
        if (this.debug) {
            console.log('datasource.ts :: connect()', col);
        }
        if (!this.refreshObs) {
            this.refreshObs = this.refreshSubject.asObservable();
            setTimeout(() => this.refreshSubject.next(), 10);
            if (this.debug) {
                console.log('datasource.ts :: connect() :: hasRefreshObj', this.refreshObs);
            }
        }
        if (this._sort) {
            const displayDataChanges = this.page ? [
                this.page.page,
                this._sort.sortChange,
                this.refreshObs
            ] :
                [
                    this._sort.sortChange,
                    this.refreshObs
                ];
            this.refreshObs = rxjs_1.merge(...displayDataChanges);
        }
        // refresh when change from either pagination, sort or search
        return this.refreshObs.pipe(operators_1.mergeMap(c => {
            if (this.debug) {
                console.log('datasource.ts :: connect() :sub: refreshObs ------- start --------- ', c);
            }
            this.loading = true;
            let query = this.searchQuery;
            if (this._sort) {
                query = query.sortBy(this._sort.active || 'id', this._sort.direction == 'asc');
            }
            if (this.page) {
                var p = this.page.pageIndex;
                var ps = this.page.pageSize;
                if (ps < 1) {
                    ps = 40;
                }
                var o = p * ps;
                // console.log ( 'paginator settings offset,limit', this.page, this.page.pageIndex * this.page.pageSize ? this.page.pageSize : 0, this.page.pageSize ? this.page.pageSize : 40 );
                query = query.offset(o).limit(this.page.pageSize ? this.page.pageSize : 40);
            }
            else {
                query.limit(500);
            }
            // console.log ( '    :sub: query', query );
            delete query.queryParams['query'];
            let queryz = [];
            if (this.filterQuery)
                queryz.push(this.filterQuery);
            if (this.searchText)
                queryz.push(this.searchText);
            if (this.dateQuery)
                queryz.push(this.dateQuery);
            if (this.baseQuery)
                queryz.push(this.baseQuery);
            if (this.assetTypeQuery)
                queryz.push(this.assetTypeQuery);
            if (queryz.length) {
                query = query.complexQuery({
                    op: 'and',
                    items: queryz
                });
            }
            // console.log ( '    :sub: queryz', queryz );
            if (this.debug) {
                console.log('datasource.ts :: connect() :sub: refreshObs ------- ending soon --------- ');
            }
            return rxjs_1.merge(query.useCache(true).queryObservable(), this.injectObs).pipe(operators_1.map(i => {
                if (this.debug) {
                    console.log('datasource.ts :: connect() :sub: observableMerge', i);
                }
                this.loading = false;
                this.results = i;
                this.loadedSubject.next(true);
                return i.items;
            }));
        }));
    }
    getSortedData() {
        return this.results ? this.results.items : null;
    }
    disconnect() { }
    injectVals(item, replaceAllItems = false) {
        if (replaceAllItems) {
            this.results.items = item;
        }
        else {
            item.forEach(i => this.results.items.push(i));
        }
        this.injectSubject.next(this.results);
    }
}
exports.VasatDataSource = VasatDataSource;
